import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";

export default function WorkoutsIcon(props) {
  const width = props.width || 30;
  const height = props.height || 30;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
          <Path
            d="M18.4114 7.43172L21.2237 16.0832L25.3241 19.1166C25.7027 19.3547 26.0306 19.6651 26.2892 20.0301C26.5478 20.395 26.7319 20.8073 26.8311 21.2434C26.9303 21.6795 26.9426 22.1309 26.8673 22.5718C26.792 23.0126 26.6306 23.4343 26.3923 23.8128L25.7878 24.7737C25.4663 25.2825 24.9564 25.6431 24.3696 25.7767C23.7828 25.9103 23.167 25.806 22.657 25.4866L4.1428 13.3803C3.63374 13.0588 3.27287 12.5487 3.13926 11.9616C3.00564 11.3746 3.11018 10.7585 3.42997 10.2484L7.7633 3.36055C8.22372 2.62822 9.47497 2.58597 9.7133 3.41689C9.97045 4.24766 10.399 5.01525 10.9714 5.67004C11.5437 6.32484 12.247 6.85229 13.0359 7.2183C14.7515 7.8978 16.6473 7.97306 18.4114 7.43172Z"
            fill="url(#paint0_linear_workouts)"
          />
          <Path
            d="M15 23.6665H2V25.8332H15V23.6665Z"
            fill="url(#paint1_linear_workouts)"
          />
          <Path
            d="M7.41667 18.25H2V20.4167H7.41667V18.25Z"
            fill="url(#paint2_linear_workouts)"
          />
          <Defs>
            <LinearGradient
              id="paint0_linear_workouts"
              x1="3.08252"
              y1="7.79717"
              x2="13.9346"
              y2="30.7439"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor="#05858A" />
              <Stop offset="1" stopColor="#2AE8CB" />
            </LinearGradient>
            <LinearGradient
              id="paint1_linear_workouts"
              x1="2"
              y1="24.1364"
              x2="2.21404"
              y2="26.7605"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor="#05858A" />
              <Stop offset="1" stopColor="#2AE8CB" />
            </LinearGradient>
            <LinearGradient
              id="paint2_linear_workouts"
              x1="2"
              y1="18.7199"
              x2="2.49803"
              y2="21.2639"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor="#05858A" />
              <Stop offset="1" stopColor="#2AE8CB" />
            </LinearGradient>
          </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
